import PageHero from '../components/PageHero';
import SectionIntro from '../components/SectionIntro';
import InfoCard from '../components/InfoCard';
import Button from '../components/Button';
import { focusAreas, homeImages, workforceApproach, workforcePipeline } from '../data/siteData';

export default function WorkforceDevelopmentPage() {
  return (
    <>
      <PageHero
        eyebrow="STEM Education & Workforce Development"
        title="Building a diverse, skilled, and job-ready clinical research workforce"
        description="Through education, training, mentorship, and real-world exposure, BrainTorch™ Bio helps learners move from interest to opportunity."
        image={homeImages.workforce}
        compact
      />

      <section className="section shell">
        <SectionIntro eyebrow="Our Approach" title="Educate, experience, empower, and employ" align="center" />
        <div className="mini-card-grid mini-card-grid--four top-gap-lg">
          {workforceApproach.map((item) => {
            const Icon = item.icon;
            return (
              <article key={item.title} className="mini-card mini-card--tall">
                <Icon size={34} />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            );
          })}
        </div>
      </section>

      <section className="section section--contrast">
        <div className="shell">
          <SectionIntro eyebrow="The Workforce Pipeline" title="From foundational training to long-term career success" align="center" />
          <div className="pipeline pipeline--five top-gap-lg">
            {workforcePipeline.map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={item.title} className="pipeline-step">
                  <div className={`pipeline-step__icon ${index === 3 ? 'pipeline-step__icon--orange' : ''}`}>
                    <Icon size={22} />
                  </div>
                  <strong>{index + 1}. {item.title}</strong>
                  <p>{item.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section shell section--tight-top">
        <SectionIntro eyebrow="Focus Areas" title="Support that strengthens learners and organizations" align="center" />
        <div className="card-grid card-grid--four top-gap-lg">
          {focusAreas.map((item) => (
            <InfoCard key={item.title} icon={item.icon} title={item.title} text={item.text} />
          ))}
        </div>
      </section>

      <section className="section shell section--tight-top">
        <div className="cta-band">
          <div>
            <h2>Investing in people. Strengthening the future.</h2>
            <p>We are committed to developing the next generation of clinical research leaders.</p>
          </div>
          <Button to="/contact#contact-connect" variant="teal">Get Involved</Button>
        </div>
      </section>
    </>
  );
}
